import { Flex } from '../../../components/Flex/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const InnerFlex = ({
  children,
  responsive,
  $justifyEnd
}) => {
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    alignItems: "center",
    inlineSize: "100%",
    columnGap: "300",
    justifyContent: $justifyEnd ? 'end' : 'space-between'
  }, responsive && {
    flexWrap: 'wrap'
  }, {
    children: children
  }));
};